import React from 'react';
import PropTypes from 'prop-types';

import { get } from 'lodash-es';

const Footer = ({ theme, app, strings }) => {
  const currentTheme = get(theme, 'current', 'coog');
  if (currentTheme !== 'coog') {
    const logo = get(theme, 'logo', {});
    return <footer className="coog-footer">{get(logo, `list.${currentTheme}.component`)}</footer>;
  }
  return (
    <footer className="coog-footer">
      <a href={get(app, 'logoLink')} className="link">
        <img alt={get(strings, 'pageTitle')} src={get(app, 'logoRef')} />
      </a>
      <div className="logo">
        <a href={get(app, 'logoLink')}>
          <h2 className="center">
            co
            <span className="blue">open</span>
            go
          </h2>
        </a>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  theme: PropTypes.object.isRequired, // eslint-disable-line
  app: PropTypes.object.isRequired, // eslint-disable-line
  strings: PropTypes.object.isRequired, // eslint-disable-line
};

export default Footer;
